import React, { Component, Fragment } from 'react'
import { Select } from '@driftt/tide-selects'
import { isNil } from 'ramda'

const determineValue = (val) => {
  if (String(val) === 'true') {
    return 1
  } else {
    return 0
  }
}

class BooleanInput extends Component {
  constructor(props) {
    super(props)

    const currentValue = !isNil(props.value) ? determineValue(props.value) : 1
    this.state = {
      currentValue 
    }

    props.onChange(Boolean(currentValue))
  }

  handleChange = ({value}) => {
    const { onChange } = this.props

    this.setState({
      currentValue: value
    })

    onChange(Boolean(value))
  }

  render() {
    const { currentValue } = this.state
    const options = [{value: 1, label: 'true'}, {value: 0, label: 'false'}]
    const selectValue = options.filter(({ value }) => value === currentValue)

    return (
      <Fragment>
        <Select
          options={options}
          value={selectValue}
          className="contact-details--typed-input-boolean"
          onChange={this.handleChange}
          placeholder={'Select a boolean value'}
          clearable={false}
          searchable={false}
        />
      </Fragment>
    )
  }
}

export default BooleanInput
